import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import withNotification from "@hooks/useNotification";
import { useReduxSelector } from "@hooks/useReduxSelector";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import { SvgExcelIcon, SvgExportXLS } from "@routes/IconeSvg";
import { uniqueId } from "lodash";
import moment from "moment-timezone";
import readXlsxFile from "read-excel-file";

import "@css/pages/employer/AddEmployer/Infopers.css";
import "@css/responsivity/responsivityDesktop/materials.css";
import { Table } from "reactstrap";

import InputFileCV from "@components/input/InputFileCV";
import ModalConfirmSimple from "@components/modals/confirmModal/ConfirmModalSimple";
import BackButton from "@components/tailwindComponents/BackButton";
import Button from "@components/tailwindComponents/Button";
import DotLoader from "@components/tailwindComponents/DotLoader";
import EmptyData from "@components/tailwindComponents/EmptyData";
import { CheckboxSimple } from "@components/tailwindComponents/index";
import SideCollapse from "@pages/layouts/components/sidebar/SideCollapse";
import DefaultCountryList from "@pages/localStorage/Pays";

import { TableImportList } from "../../utils/tableImportList.config";
import {
  REGEX_ACCOUNT_NUMBER,
  REGEX_EMAIL,
  REGEX_PHONE,
  REGEX_PHONE_INVERSE,
  REGEX_POST_NUMBER,
  REGEX_SOCIAL_NUMBER,
  REGEX_TRANSIT_NUMBER
} from "@helpers/_constants";
import {
  checkEnterpriseId,
  cloneValue,
  downloadBlobFile as download,
  getDateToSave,
  toString
} from "@helpers/_functions";
import { Employer, EmployerSalary, Users } from "@services/all.services";
import { getDateToRenderInImport } from "@utils/date.utls";
import ItemEmployeList from "./ItemEmployeList";
import { HEADER_STRING } from "./_utils";

const toEmail = (email) => toString(email).replace(/[,]/g, ".");



// Function pour les status
const useStylesBootstrap = makeStyles(() => ({
  arrow: {
    color: "#3F3F51"
  },
  tooltip: {
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "23px 17px"
  }
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();
  return (
    <Tooltip
      arrow
      classes={classes}
      {...props}
    />
  );
}

// End Function pour les status

const isToFill = (employe = {}) => {
  const { personnalInformation /*, adress*/, emails, emploi } = employe;
  return (
    !personnalInformation?.legalFirstName?.toString()?.trim() ||
    !personnalInformation?.legalName?.toString()?.trim() ||
    !personnalInformation?.legalGender ||
    !REGEX_EMAIL.test(emails?.personalEmail) ||
    !emploi?.poste?.trim() ||
    !emploi?.emplacement?.length ||
    !emploi?.authorization?.trim() ||
    !emploi?.valueHierarchicalSelected?.trim()
  );
};

let listEmployesCopy = [];
let neverShowCopy = false;

function ImportList({ showError, showSuccess, returnToEmployeList }) {
  const { employers, emplacements, postes, permissions } = useReduxSelector(
    ({ commonData }) => commonData
  );

  const [listEmployes, setListEmployes] = useState([]);
  const [toFillNumber, setToFillNumber] = useState(0);
  const [duplicateNumber, setDuplicateNumber] = useState(0);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedEmployeList, setSelectedEmployeList] = useState([]);
  const [dataForChange, setDataForChange] = useState({});
  const [userSuccess, setUserSuccess] = useState([]);
  const [userFailed, setUserFailed] = useState([]);
  const [uploadResponse, setUploadResponse] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [neverShowDeleteModal, setNeverShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState(TableImportList);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [tempDataForChange, setTempDataForChange] = useState({});

  const { t } = useTranslation(["pages.employés.importation", "message"]);

  useEffect(() => {
    toFillAndDuplicateCount(listEmployes);
  }, [listEmployes]);

  useEffect(() => {
    neverShowCopy = neverShowDeleteModal;
  }, [neverShowDeleteModal]);

  const toFillAndDuplicateCount = (listes = listEmployesCopy) => {
    let toFillNumb = 0;
    let duplicateNumb = 0;
    for (const employe of listes) {
      if (employe.isToFill) toFillNumb++;
      if (employe.isMailAlreadyInDB || employe.isNumberAlreadyInDB) {
        duplicateNumb++;
      }
    }
    setToFillNumber(toFillNumb);
    setDuplicateNumber(duplicateNumb);
  };

  const dowloadGabary = (e) => {
    Employer.downloadGabarit()
      .then((res) => {
        e.preventDefault();
        download(res.data, "gabarit.xlsx");
      })
      .catch((e) => console.error(e));
  };

  const onChangeFile = (file) => {
    if (file.meta.status === "done") {
      setSelectedEmployeList([]);
      setFirstLoading(true);
      setUploadResponse(false);
      readXlsxFile(file.file).then((rows) => {
        if (!rows.length || JSON.stringify(rows[1]) !== HEADER_STRING) {
          showError("gabarit_systeme");
          setFirstLoading(false);
          return;
        }
        let tmpList = [];
        let length = 0;
        if (rows.length > 102) {
          showError("max_imported", { object: "employees" });
          length = 102;
        } else {
          length = rows.length;
        }
        let emailEmpty = false;
        for (let r = 2; r < length; r++) {
          const [
            legalFirstName, // corresponding of the first column in employe gabarit: A
            legalName,
            personalEmail,
            hiringDate,
            dateOfBirth,
            personalPhone,
            personalPhonePostNumber,
            firstAdress,
            secondAdress,
            numEmployer,
            firstNameUsed,
            nameUsed,
            professionalEmail,
            professionalPhone,
            professionalPhonePostNumber,
            contactName1,
            contactPhone1,
            contactEmail1,
            employeeRelationship1,
            contactName2,
            contactPhone2,
            contactEmail2,
            employeeRelationship2, // corresponding of the last column in excel employe gabarit: U
            socialInsuranceNumber,
            transitNumber,
            institutionNumber,
            accountNumber
          ] = rows[r];
          let employe = {
            _id: uniqueId(),
            isToFill: false,
            personnalInformation: {
              legalFirstName: toString(legalFirstName),
              legalName: toString(legalName),
              legalGender: "",
              firstNameUsed: toString(firstNameUsed),
              nameUsed: toString(nameUsed),
              dateOfBirth: getDateToRenderInImport(dateOfBirth)
            },
            emails: {
              personalEmail: toEmail(personalEmail),
              personalPhone: toString(personalPhone),
              professionalEmail: toEmail(professionalEmail),
              professionalPhone: toString(professionalPhone),
              personalPhonePostNumber: personalPhonePostNumber || "",
              professionalPhonePostNumber: professionalPhonePostNumber || ""
            },
            adress: {
              city: "",
              zipCode: "",
              province: "",
              country: "",
              firstAdress: toString(firstAdress),
              secondAdress: toString(secondAdress)
            },
            emploi: {
              hiringDate: getDateToRenderInImport(hiringDate),
              poste: "",
              emplacement: "",
              valueHierarchicalSelected: "",
              valueSousGroupeSelected: "",
              authorization: "",
              numEmployer: toString(numEmployer)
            },
            BankingAndInsuranceInformation: {
              socialInsuranceNumber: socialInsuranceNumber || "",
              transitNumber: transitNumber || "",
              institutionNumber: institutionNumber || "",
              accountNumber: accountNumber || ""
            },
            firstEmergencyContact: {
              contactName: toString(contactName1),
              contactPhone: toString(contactPhone1),
              employeeRelationship: toString(employeeRelationship1),
              contactEmail: toEmail(contactEmail1)
            },
            secondEmergencyContact: {
              contactName: toString(contactName2),
              contactPhone: toString(contactPhone2),
              employeeRelationship: toString(employeeRelationship2),
              contactEmail: toEmail(contactEmail2)
            }
          };
          employe.isToFill = isToFill(employe);
          if (!employe.emails.personalEmail) {
            emailEmpty = true;
          }
          tmpList.push(employe);
        }
        if (emailEmpty) {
          showError("gabarit_email_obligatory");
        }
        if (tmpList.length === 0) {
          showError(
            "Le fichier Excel doit contenir au moins un élément pour être traité"
          );
          setFirstLoading(false);
        }
        Employer.importLists({
          tmpList,
          enterpriseId: localStorage.getItem("enterpriseId"),
          adminUserId: localStorage.getItem("idAdminEnterprise")
        })
          .then((responses) => {
            listEmployesCopy = responses;
            setListEmployes(responses);
          })
          .catch((e) => console.error(e))
          .finally(() => setFirstLoading(false));
      });
    }
  };

  const selectItem = (item) => {
    setSelectedEmployeList((prevState) => {
      if (prevState.some((employe) => employe._id === item?._id)) {
        return prevState.filter((itm) => itm._id !== item?._id);
      }
      return prevState.concat(item);
    });
  };

  const selectAllItem = (ev) => {
    if (ev.target.checked) {
      setSelectedEmployeList([...listEmployesCopy]);
      setAllSelected(true);
    } else {
      setSelectedEmployeList([]);
      setAllSelected(false);
    }
  };

  const handlePersonnalInformation = (ev, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    if (ev?.target) {
      let inputName = ev.target.name;
      let donnees = ev.target.value;
      currentEmploye.personnalInformation[inputName] = donnees;
    } else {
      currentEmploye.personnalInformation.legalGender = ev;
    }
    currentEmploye.isToFill = isToFill(currentEmploye);
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handleChangeBankingInformation = (ev, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    if (ev?.target) {
      let inputName = ev.target.name;
      let donnees = ev.target.value;
      currentEmploye.BankingAndInsuranceInformation[inputName] = donnees;
    }
    currentEmploye.isToFill = isToFill(currentEmploye);
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handlePhone = (personalPhone /*, rowID*/, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    const cleanedPhone = personalPhone.replace(REGEX_PHONE_INVERSE, "");
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    currentEmploye.emails.personalPhone = cleanedPhone;
    currentEmploye.isToFill = isToFill(currentEmploye);
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handleFirstEmergencyContact = (ev, employeId) => {
    if (ev?.target) {
      const inputName = ev.target.name;
      let donnees = ev.target.value;
      if (inputName === "contactPhone") {
        donnees = donnees.replace(REGEX_PHONE_INVERSE, "");
      }
      const rowID = listEmployesCopy.findIndex(
        (employe) => employe._id === employeId
      );
      const currentEmploye = cloneValue(listEmployesCopy[rowID]);
      currentEmploye.firstEmergencyContact[inputName] = donnees;
      listEmployesCopy[rowID] = currentEmploye;
      setListEmployes([...listEmployesCopy]);
    }
  };

  const handleSecondEmergencyContact = (ev, employeId) => {
    if (ev?.target) {
      const inputName = ev.target.name;
      let donnees = ev.target.value;
      if (inputName === "contactPhone") {
        donnees = donnees.replace(REGEX_PHONE_INVERSE, "");
      }
      const rowID = listEmployesCopy.findIndex(
        (employe) => employe._id === employeId
      );
      const currentEmploye = cloneValue(listEmployesCopy[rowID]);
      currentEmploye.secondEmergencyContact[inputName] = donnees;
      listEmployesCopy[rowID] = currentEmploye;
      setListEmployes([...listEmployesCopy]);
    }
  };

  const handleEmails = (ev, employeId) => {
    if (ev?.target) {
      const inputName = ev.target.name;
      let donnees = ev.target.value;
      if (inputName === "professionalPhone") {
        donnees = donnees.replace(REGEX_PHONE_INVERSE, "");
      }
      const rowID = listEmployesCopy.findIndex(
        (employe) => employe._id === employeId
      );
      const currentEmploye = cloneValue(listEmployesCopy[rowID]);

      currentEmploye.emails[inputName] = donnees;
      listEmployesCopy[rowID] = currentEmploye;
      setListEmployes([...listEmployesCopy]);
    }
  };

  const handlePersonalEmail = async (personalEmail, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let employe = listEmployesCopy[rowID];
    if (REGEX_EMAIL.test(personalEmail)) {
      const response = await Users.verifyExistEmail({ email: personalEmail });
      employe.isMailAlreadyInDB = response.userAlreadyExist;
    }
    const newDuplicates = listEmployesCopy.filter(
      (item) =>
        item.emails.personalEmail === personalEmail && employe._id !== item._id
    );
    let previousDuplicates = [];
    if (employe.hasEmailDuplication)
      previousDuplicates = listEmployesCopy.filter(
        (item) =>
          item.emails.personalEmail === employe.emails.personalEmail &&
          employe._id !== item._id
      );
    const duplicated = newDuplicates.length > 0;
    const unDuplicate = previousDuplicates.length === 1;
    if (duplicated || unDuplicate) {
      for (let [index, item] of listEmployesCopy.entries()) {
        if (
          unDuplicate &&
          item.emails.personalEmail === employe.emails.personalEmail &&
          item._id !== employe._id
        ) {
          item.hasEmailDuplication = false;
          listEmployesCopy[index] = cloneValue(item);
        }
        if (
          item.emails.personalEmail === personalEmail &&
          item._id !== employe._id
        ) {
          item.hasEmailDuplication = true;
          listEmployesCopy[index] = cloneValue(item);
        }
      }
    }
    employe.hasEmailDuplication = duplicated;
    employe.emails.personalEmail = personalEmail;
    employe.isToFill = isToFill(employe);
    listEmployesCopy[rowID] = cloneValue(employe);
    setListEmployes([...listEmployesCopy]);
  };

  const handleAdress = (adress, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    if (adress?.target) {
      //handle additional adress change => secondAdress
      const { name, value } = adress.target;
      currentEmploye.adress[name] = value;
    } else if (adress?.additionalInfo) {
      // handle adress autocomplete select =>  firstAdress
      const { address, additionalInfo } = adress;
      currentEmploye.adress = {
        ...currentEmploye.adress,
        firstAdress: address,
        ...additionalInfo
      };
    }
    currentEmploye.isToFill = isToFill(currentEmploye);
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handleEmployeNumberChange = async (newNumber, employeId) => {
    const employeIndex = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmployee = listEmployesCopy[employeIndex];

    if (currentEmployee.emploi.numEmployer === newNumber) {
      return;
    }

    if (newNumber) {
      const response = await EmployerSalary.checkNumEmploye(
        newNumber,
        employeId
      );
      currentEmployee.isNumberAlreadyInDB = Boolean(response?.length > 0);
    } else {
      currentEmployee.isNumberAlreadyInDB = false;
    }

    const previousDuplicates = listEmployesCopy.filter(
      (employe) =>
        employe.emploi.numEmployer &&
        currentEmployee.emploi.numEmployer &&
        employe.emploi.numEmployer === currentEmployee.emploi.numEmployer &&
        employe._id !== employeId
    );
    const newDuplicates = listEmployesCopy.filter(
      (employe) =>
        newNumber &&
        employe.emploi.numEmployer &&
        employe.emploi.numEmployer === newNumber &&
        employe._id !== employeId
    );

    currentEmployee = {
      ...currentEmployee,
      emploi: {
        ...currentEmployee.emploi,
        numEmployer: newNumber
      },
      hasNumberDuplication: newDuplicates.length > 0
    };

    listEmployesCopy = listEmployesCopy.map((_employe) => {
      if (_employe._id === currentEmployee._id) {
        return currentEmployee;
      }

      // Remove duplication from previous duplicates
      if (
        previousDuplicates.length === 1 &&
        _employe._id === previousDuplicates[0]?._id
      ) {
        return {
          ..._employe,
          hasNumberDuplication: false
        };
      }

      // Add duplication to new duplicates
      if (newDuplicates.some((duplicate) => duplicate._id === _employe._id)) {
        return {
          ..._employe,
          hasNumberDuplication: true
        };
      }

      return _employe;
    });

    setListEmployes([...listEmployesCopy]);
  };

  const handleEmploi = (ev, employeId, name) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    if (ev?.target) {
      let inputName = ev.target.name;
      let donnees = ev.target.value;
      currentEmploye.emploi[inputName] = donnees;
    } else {
      if (name === "hiringDate") currentEmploye.emploi.hiringDate = ev;
      if (name === "dateOfBirth")
        currentEmploye.personnalInformation.dateOfBirth = ev;
    }
    currentEmploye.isToFill = isToFill(currentEmploye);
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handleEmploiInfos = (ev, label, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    currentEmploye.emploi[label] = ev;
    currentEmploye.isToFill = isToFill(currentEmploye);
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handleGroups = (ev, label, employeId) => {
    const rowID = listEmployesCopy.findIndex(
      (employe) => employe._id === employeId
    );
    let currentEmploye = cloneValue(listEmployesCopy[rowID]);
    currentEmploye[label] = ev;
    listEmployesCopy[rowID] = currentEmploye;
    setListEmployes([...listEmployesCopy]);
  };

  const handleDataForChange = (ev, label) => {
    setDataForChange((prevDataChange) => {
      prevDataChange[label] = ev;
      return { ...prevDataChange };
    });
  };

  const deleteListEmployes = () => {
    setSelectedEmployeList([]);
    listEmployesCopy = [];
    setListEmployes([]);
  };

  const saveDataChange = () => {
    setLoading(true);

    setTempDataForChange({ ...dataForChange });
    for (let selectedEmploye of selectedEmployeList) {
      let idx = listEmployesCopy.findIndex(
        (o) => o._id === selectedEmploye._id
      );
      let employeToUpdate = cloneValue(listEmployesCopy[idx]);
      if (dataForChange.legalGender) {
        employeToUpdate.personnalInformation.legalGender =
          dataForChange.legalGender;
      }
      if (dataForChange.country) {
        employeToUpdate.adress.country = dataForChange.country;
      }
      if (dataForChange.poste) {
        employeToUpdate.emploi.poste = dataForChange.poste;
      }
      if (dataForChange.emplacement) {
        employeToUpdate.emploi.emplacement = dataForChange.emplacement;
      }
      if (dataForChange.authorization) {
        employeToUpdate.emploi.authorization = dataForChange.authorization;
      }
      if (dataForChange.valueHierarchicalSelected) {
        employeToUpdate.emploi.valueHierarchicalSelected =
          dataForChange.valueHierarchicalSelected;
      }
      if (dataForChange.groupes) {
        employeToUpdate.groupes = dataForChange.groupes;
      }
      employeToUpdate.isToFill = isToFill(employeToUpdate);
      listEmployesCopy[idx] = employeToUpdate;
    }

    setListEmployes([...listEmployesCopy]);
    setLoading(false);
  };

  function removeOldDuplicationError(oldEmploye, actualEmployeList) {
    const oldDuplications = actualEmployeList.filter(
      (employe) => (employe) =>
        employe?.emails?.personalEmail === oldEmploye?.emails?.personalEmail
    );

    if (oldDuplications.length !== 1) {
      return actualEmployeList;
    }

    const oldDuplicatedEmploye = oldDuplications[0];

    return actualEmployeList.map((employe) => {
      if (employe !== oldDuplicatedEmploye) {
        return employe;
      }

      return {
        ...employe,
        hasNumberDuplication: false,
        hasEmailDuplication: false
      };
    });
  }

  const deleteSelectedEmployees = () => {
    const selectedEmployeIds = selectedEmployeList.map((e) => e._id);

    let nextEmployeList = listEmployesCopy?.filter(
      (employe) => !selectedEmployeIds.includes(employe?._id)
    );

    for (let selectedEmployeId of selectedEmployeIds) {
      const selectedEmploye = listEmployesCopy.find(
        (employe) => employe?._id === selectedEmployeId
      );

      if (selectedEmploye) {
        nextEmployeList = removeOldDuplicationError(
          selectedEmploye,
          nextEmployeList
        );
      }
    }

    listEmployesCopy = nextEmployeList;
    setListEmployes([...nextEmployeList]);

    //Delete from selected item
    setSelectedEmployeList((prevState) => {
      return prevState.filter(
        (employe) => !selectedEmployeIds.includes(employe?._id)
      );
    });

    if (modalConfirm) {
      setModalConfirm(false);
    }
  };

  const handleDeleteEmploye = (e) => {
    e.preventDefault();
    if (neverShowCopy) {
      deleteSelectedEmployees();
    } else {
      toggleModalConfirm();
    }
  };

  const toggleModalConfirm = () => {
    setModalConfirm(!modalConfirm);
    setNeverShowDeleteModal(false);
  };

  const createAccount = async () => {
    if (!loading) {
      let dataToSave =
        selectedEmployeList.length > 0
          ? selectedEmployeList.map((item) =>
              listEmployesCopy.find((employe) => employe._id === item._id)
            )
          : listEmployesCopy;
      dataToSave = dataToSave.filter((item) => item?._id);
      if (
        dataToSave &&
        dataToSave.length > 0 &&
        dataToSave.some((employe) => employe?.isToFill)
      ) {
        showError("field_obligatory");
        return;
      } else if (
        duplicateNumber ||
        dataToSave.some(
          (employe) =>
            employe?.isMailAlreadyInDB || employe?.isNumberAlreadyInDB
        )
      ) {
        showError("duplicated_in_list");
        return;
      }

      // validation
      for (const data of dataToSave) {
        // Validate phone numbers
        const phones = [
          data?.emails?.personalPhone,
          data?.emails?.professionalPhone,
          data?.firstEmergencyContact?.contactPhone,
          data?.secondEmergencyContact?.contactPhone
        ];

        if (phones.some((phone) => phone && !REGEX_PHONE.test(phone))) {
          showError("invalid_field_value");
          return;
        }

        // Validate post numbers
        const postNumbers = [
          data?.emails?.personalPhonePostNumber,
          data?.emails?.professionalPhonePostNumber
        ];

        if (
          postNumbers.some(
            (postNumber) => postNumber && !REGEX_POST_NUMBER.test(postNumber)
          )
        ) {
          showError("Le numéro de poste doit contenir 3 à 6 chiffres");
          return;
        }

        // Validate social insurance number
        const socialNumber =
          data?.BankingAndInsuranceInformation?.socialInsuranceNumber;
        if (socialNumber) {
          if (!REGEX_SOCIAL_NUMBER.test(socialNumber)) {
            showError("Le numéro d'assurance social doit contenir 9 chiffres");
            return;
          }
        }

        // Validate transit number
        const transitNumber =
          data?.BankingAndInsuranceInformation?.transitNumber;
        if (transitNumber && !REGEX_TRANSIT_NUMBER.test(transitNumber)) {
          showError("Le numéro de transit doit contenir 5 chiffres");
          return;
        }

        // Validate institution number
        const institutionNumber =
          data?.BankingAndInsuranceInformation?.institutionNumber;
        if (institutionNumber && !REGEX_POST_NUMBER.test(institutionNumber)) {
          showError("Le numéro d'institution doit contenir 3 chiffres");
          return;
        }

        // Validate account number
        const accountNumber =
          data?.BankingAndInsuranceInformation?.accountNumber;
        if (accountNumber) {
          if (!REGEX_ACCOUNT_NUMBER.test(accountNumber)) {
            showError(
              "Le numéro de compte doit contenir entre 7 et 12 chiffres"
            );
            return;
          }
        }
      }

      dataToSave = dataToSave.map((data) => {
        const hiringDate = data.emploi?.hiringDate;
        data.emploi.hiringDate =
          hiringDate && moment(hiringDate).isValid()
            ? moment(hiringDate).format("YYYY-MM-DD")
            : "";
        if (data.personnalInformation.dateOfBirth) {
          const dateOfBirth = data.personnalInformation?.dateOfBirth;
          data.personnalInformation.dateOfBirth =
            dateOfBirth && moment(dateOfBirth).isValid()
              ? moment(dateOfBirth).format("YYYY-MM-DD")
              : "";
        }
        if (data.emploi?.holiday) {
          const renewalDay = data.emploi.holiday?.renewalDay;
          data.emploi.holiday.renewalDay = getDateToSave(renewalDay) || "";
          data.emploi.emplacement = data.emploi?.emplacement.map(
            (item) => item._id
          );
        }
        return data;
      });
      setLoading(true);
      const body = {
        data: dataToSave,
        enterpriseId: checkEnterpriseId(),
        adminId: localStorage.getItem("idAdminEnterprise")
      };
      Employer.saveLists(body)
        .then((responses) => {
          const { userSuccess, userFailed } = responses;
          listEmployesCopy = [];
          setListEmployes([]);
          setSelectedEmployeList([]);
          setUserSuccess(userSuccess);
          setUserFailed(userFailed);
          if (userFailed?.length) {
            showError("error_occured", {
              mode: "action_mode_register",
              object: "employee"
            });
          } else {
            // const object =
            //   userSuccess?.length > 1 ? "employeesUpper" : "employeeOnlyUpper";
            showSuccess("new_account");
          }
          setUploadResponse(true);
        })
        .catch((e) => {
          console.error(e);
          showError("error_occured", {
            mode: "action_mode_register",
            object: "employee"
          });
        })
        .finally(() => setLoading(false));
    }
  };

  const exportUserToExcel = (dataUser, sheetName) => {
    let dataToSend = { dataUser };
    let theFileName = `user-export-${Date.now()}.xlsx`;
    const _supplementary = {
      theFileName: theFileName,
      sheetName: sheetName,
      enterpriseId: localStorage.getItem("enterpriseId")
    };
    dataToSend = Object.assign(dataToSend, _supplementary);
    Employer.export(dataToSend)
      .then((_r) => {
        Employer.download(theFileName)
          .then((resp) => {
            theFileName = "user-export".concat(
              "-",
              sheetName.toLowerCase(),
              ".xlsx"
            );
            download(resp.data, theFileName);
            if (resp.statusText !== "OK") {
              showError("file_failed_downloaded");
            }
          })
          .catch((e) => {
            console.error(e);
          });
      })
      .catch((e) => {
        console.error(e);
      });
  };
  return (
    <div className="arh-relative arh-mb-10 arh-overflow-x-hidden arh-bg-white arh-p-4 arh-px-9">
      <div className="arh-mb-4">
        <BackButton onClick={returnToEmployeList} />
      </div>

      {uploadResponse ? (
        <div className="arh-flex arh-justify-between">
          <div className="w-45">
            <div className="grey_card grey_card--badge_wrapper arh-flex arh-items-center arh-justify-between">
              <div className="semibold arh-flex">
                {t("Importations réussies")} :
                <span className="badge_simple badge_simple--success semibold">
                  {userSuccess.length}
                </span>
              </div>

              <div
                className="semibold cursor_pointer arh-flex arh-items-center"
                onClick={() => exportUserToExcel(userSuccess, "Réussies")}
              >
                {t("Télécharger la liste")}
                <span className="d-block ml-2">{SvgExportXLS()}</span>
              </div>
            </div>
            <div className="table-responsive table_employer-imported mt-5">
              <table className="arh-mt-0 arh-w-full arh-table-fixed arh-items-center arh-font-poppins">
                <thead className="arh-sticky -arh-top-[1px] arh-z-[2]">
                  <tr>
                    <th className="arh-w-1/3 arh-bg-greyColor arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                      {t("Prénom légal")}
                    </th>
                    <th className="arh-w-1/3 arh-bg-greyColor arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                      {t("Nom légal")}
                    </th>
                    <th className="arh-w-1/3 arh-bg-greyColor arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                      {t("Courriel de correspondance")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userSuccess.length === 0 ? (
                    <tr>
                      <td colSpan={3}>
                        <EmptyData>{t("Aucun résultat à afficher")}</EmptyData>
                      </td>
                    </tr>
                  ) : (
                    userSuccess.map((employe) => {
                      return (
                        <tr key={employe._id}>
                          <td className="arh-border-0 arh-border-b arh-border-solid arh-border-greyBorderInput arh-p-4 arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                            {employe.personnalInformation.legalFirstName}
                          </td>
                          <td className="arh-border-0 arh-border-b arh-border-solid arh-border-greyBorderInput arh-p-4 arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                            {employe.personnalInformation.legalName}
                          </td>
                          <td className="arh-border-0 arh-border-b arh-border-solid arh-border-greyBorderInput arh-p-4 arh-font-poppins arh-text-xs  arh-font-medium arh-text-[#393C40]">
                            {employe.emails.personalEmail}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-45">
            <div className="grey_card grey_card--badge_wrapper arh-flex arh-items-center arh-justify-between">
              <div className="semibold arh-flex">
                {t("Échecs")} :
                <span className="badge_simple badge_simple--danger semibold">
                  {userFailed.length}
                </span>
              </div>
              <div
                className="semibold cursor_pointer arh-flex arh-items-center"
                onClick={() => exportUserToExcel(userFailed, "Échecs")}
              >
                {t("Télécharger la liste")}
                <span className="d-block ml-2">{SvgExportXLS()}</span>
              </div>
            </div>
            <div className="table-responsive table_employer-imported mt-5">
              <table className="arh-mt-0 arh-w-full arh-table-fixed arh-items-center">
                <thead className="arh-sticky -arh-top-[1px] arh-z-[2]">
                  <tr>
                    <th className="arh-w-1/3 arh-bg-greyColor arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                      {t("Prénom légal")}
                    </th>
                    <th className="arh-w-1/3 arh-bg-greyColor arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                      {t("Nom légal")}
                    </th>
                    <th className="arh-w-1/3 arh-bg-greyColor arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                      {t("Courriel de correspondance")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userFailed.length === 0 ? (
                    <tr>
                      <td colSpan={3}>
                        <EmptyData>{t("Aucun résultat à afficher")}</EmptyData>
                      </td>
                    </tr>
                  ) : (
                    userFailed.map((employe) => {
                      return (
                        <tr key={employe._id}>
                          <td className="arh-w-full  arh-border-0 arh-border-b arh-border-solid arh-border-greyBorderInput arh-p-4 arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                            {employe.personnalInformation.legalFirstName}
                          </td>
                          <td className="arh-w-full  arh-border-0 arh-border-b arh-border-solid arh-border-greyBorderInput arh-p-4 arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                            {employe.personnalInformation.legalName}
                          </td>
                          <td className="arh-w-full  arh-border-0 arh-border-b arh-border-solid arh-border-greyBorderInput arh-p-4 arh-font-poppins arh-text-xs arh-font-medium arh-text-[#393C40]">
                            {employe.emails.personalEmail}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div
            className={
              listEmployes.length
                ? "headerReturn head_status_inventaire_resp arh-flex arh-justify-between desktop-l:arh-flex-col "
                : "headerReturn flex-justify-end head_status_inventaire_resp arh-flex desktop-l:arh-flex-col "
            }
          >
            <div
              className={
                listEmployes.length
                  ? "responsive_item_head_import arh-mb-[1rem] arh-flex desktop-l:arh-w-full"
                  : " responsive_item_head_import d-none arh-mb-[1rem] desktop-l:arh-w-full"
              }
            >
              <div className="arh-mr-[0.5rem] arh-flex arh-w-full arh-items-center arh-whitespace-nowrap arh-rounded-[8px] arh-bg-greyColor arh-p-[0.688rem] arh-font-poppins arh-text-[13px] arh-font-medium arh-text-[#444444] ">
                <BootstrapTooltip
                  title={t("Prêt à être importé")}
                  placement="top-end"
                >
                  <span className="dots_statut status_green"></span>
                </BootstrapTooltip>
                {t("Total des employés")}
                <span className="arh-ml-[0.575rem] arh-flex arh-min-w-[2.813rem] arh-items-center arh-justify-center arh-rounded-[99px] arh-bg-[#73C7B7]/[0.4] arh-p-[0.188rem] arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-[#468579] ">
                  {listEmployes.length}
                </span>
              </div>

              <div className="arh-mr-[0.5rem] arh-flex arh-w-full arh-items-center arh-whitespace-nowrap arh-rounded-[8px] arh-bg-greyColor arh-p-[0.688rem] arh-font-poppins arh-text-[13px] arh-font-medium arh-text-[#444444] ">
                <BootstrapTooltip
                  title={t("À compléter")}
                  placement="top-end"
                >
                  <span className="dots_statut status_error"></span>
                </BootstrapTooltip>
                {t("À compléter")}
                <span className="arh-ml-[0.575rem] arh-flex arh-min-w-[2.813rem] arh-items-center arh-justify-center arh-rounded-[99px] arh-bg-[#F36242]/[0.2] arh-p-[0.188rem] arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-[#F36242] ">
                  {toFillNumber}
                </span>
              </div>

              <div className="arh-mr-[0.5rem] arh-flex arh-w-full arh-items-center arh-whitespace-nowrap arh-rounded-[8px] arh-bg-greyColor arh-p-[0.688rem] arh-font-poppins arh-text-[13px] arh-font-medium arh-text-[#444444] ">
                <BootstrapTooltip
                  title={t("Duplication")}
                  placement="top-end"
                >
                  <span className="dots_statut status_yellow"></span>
                </BootstrapTooltip>
                {t("Doublons")}
                <span className="arh-ml-[0.575rem] arh-flex arh-min-w-[2.813rem] arh-items-center arh-justify-center arh-rounded-[99px] arh-bg-[#F5D954]/[0.4] arh-p-[0.188rem] arh-text-center arh-font-poppins arh-text-xs arh-font-semibold arh-text-[#BDA018] ">
                  {duplicateNumber}
                </span>
              </div>
            </div>
            <div className="arh-grid arh-grid-cols-3 arh-items-baseline arh-gap-4 desktop-l:arh-flex desktop-l:arh-w-full desktop-l:arh-justify-end">
              {selectedEmployeList.length ? (
                <button
                  className="altee_btn altee_btn--green-outlined altee_btn--sm mr-2 flex-justify-center medium arh-flex arh-items-center"
                  disabled={selectedEmployeList.length === 0 || loading}
                  onClick={handleDeleteEmploye}
                >
                  {t("Effacer")}
                  {selectedEmployeList.length ? (
                    <span className="badge--circleBtn semibold">
                      {selectedEmployeList.length}
                    </span>
                  ) : (
                    ""
                  )}
                </button>
              ) : (
                ""
              )}
              <Button
                className="desktop-l:!arh-w-fit"
                variant="green-outlined"
                onClick={dowloadGabary}
                icon={<SvgExcelIcon />}
              >
                {t("Télécharger le gabarit")}
              </Button>

              <div className="importBtn desktop-l:!arh-w-fit">
                <InputFileCV
                  className="simple_upload_file "
                  classNameTitle="arh-hidden "
                  label="Importer votre fichier"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  handleChangeStatus={onChangeFile}
                  deleteListFile={deleteListEmployes}
                />
              </div>

              <Button
                className="desktop-l:!arh-w-fit"
                onClick={createAccount}
                disabled={listEmployes.length === 0 || loading}
              >
                {t("Enregistrer")}
              </Button>
            </div>
          </div>
          <div className="arh-relative arh-mt-5">
            <div className="import-list-tableContainer">
              <div className="table-responsive table_employer-imported">
                <Table className="align-items-center table-flush table_employer position-relative arh-font-poppins">
                  <thead className="thead-light">
                    {listEmployes.length !== 0 ? (
                      <tr className="tr_head_table_modele">
                        <th className="title_table_employer arh-p-4 arh-text-xs arh-font-semibold arh-text-black"></th>
                        <th className="title_table_employer arh-p-4 arh-text-xs arh-font-semibold arh-text-black">
                          <CheckboxSimple
                            checked={allSelected}
                            onChange={selectAllItem}
                            disabled={!listEmployes.length}
                          />
                        </th>
                        {selectedColumn.map((column) => (
                          <th
                            key={column.id}
                            className="title_table_employer arh-p-4 arh-text-xs arh-font-semibold arh-text-black"
                          >
                            {t(column.name)}
                          </th>
                        ))}
                      </tr>
                    ) : (
                      <tr className="tr_head_table_modele">
                        <th className="arh-p-4 arh-text-xs arh-font-semibold arh-text-black "></th>
                        <th className="arh-p-4 arh-text-xs arh-font-semibold arh-text-black ">
                          <CheckboxSimple
                            checked={allSelected}
                            onChange={selectAllItem}
                            disabled={!listEmployes.length}
                          />
                        </th>
                        {selectedColumn.map((column) => (
                          <th
                            key={column.id}
                            className="arh-p-4 arh-text-xs arh-font-semibold arh-text-black "
                          >
                            {t(column.name)}
                          </th>
                        ))}
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {firstLoading ? (
                      <tr>
                        <td colSpan={17}>
                          <div className="arh-h-[40dvh]">
                            <DotLoader size="small" />
                          </div>
                        </td>
                      </tr>
                    ) : listEmployes.length === 0 ? (
                      <tr>
                        <td colSpan={17}>
                          <EmptyData>
                            {t("Aucun résultat à afficher")}
                          </EmptyData>
                        </td>
                      </tr>
                    ) : (
                      listEmployes.map((employe) => (
                        <tr key={employe._id}>
                          <ItemEmployeList
                            employe={employe}
                            selectedColumn={selectedColumn}
                            isChecked={selectedEmployeList?.some(
                              (selectedEmploye) =>
                                selectedEmploye._id === employe._id
                            )}
                            selectItem={selectItem}
                            handlePersonnalInformation={
                              handlePersonnalInformation
                            }
                            handleChangeBankingInformation={
                              handleChangeBankingInformation
                            }
                            handlePersonalEmail={handlePersonalEmail}
                            handleEmails={handleEmails}
                            handleAdress={handleAdress}
                            handleEmploi={handleEmploi}
                            handleEmployeNumberChange={
                              handleEmployeNumberChange
                            }
                            handleEmploiInfos={handleEmploiInfos}
                            handleGroups={handleGroups}
                            postList={postes}
                            emplacementList={emplacements}
                            permissionList={permissions}
                            userList={employers}
                            handlePhone={handlePhone}
                            handleFirstEmergencyContact={
                              handleFirstEmergencyContact
                            }
                            handleSecondEmergencyContact={
                              handleSecondEmergencyContact
                            }
                          />
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <SideCollapse
              TableImportList={TableImportList}
              selectedColumn={selectedColumn}
              setSelectedColumn={setSelectedColumn}
              selectedItemNumber={selectedEmployeList?.length}
              allPostes={postes}
              emplacementList={emplacements}
              allPermissions={permissions}
              allUsers={employers}
              DefaultCountryList={DefaultCountryList}
              handleDataForChange={handleDataForChange}
              handleSaveData={saveDataChange}
              dataForChange={dataForChange}
              setDataForChange={setDataForChange}
              tempDataForChange={tempDataForChange}
            />
          </div>

          <ModalConfirmSimple
            isOpen={modalConfirm}
            onClickClose={toggleModalConfirm}
            handleDelete={deleteSelectedEmployees}
            neverShowDeleteModal={neverShowDeleteModal}
            setNeverShowDeleteModal={setNeverShowDeleteModal}
            confirmationMessage={t("importation_remove_multiple_rows")}
          />
        </>
      )}
    </div>
  );
}

export default withNotification(ImportList);
